/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import SeasonsIcon from "../../../../../../shared/icons/player/Seasons.svg";
import { usePlayerSettings } from "../../../../../BasePlayer";
import { useOverlayState } from "../../../../../Overlay";
import { DropdownMenu, ToggleButton } from "../../../../Base";
import { AvailableSectionProvider } from "../Settings/AvailableSectionContext";

import { MainSection } from "./MainSection";
import { SeasonsSection } from "./SeasonsSection";

export const SeasonsButton = () => {
  const { t } = usePlayerTranslation();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { toggleSettings } = useOverlayState();

  return (
    <ToggleButton
      variant="secondary"
      icon={<SeasonsIcon aria-hidden="true" focusable="false" />}
      tooltip={t("SEASONS")}
      tooltipOffset={tooltipOffset}
      onVisibilityChange={toggleSettings}
      iconOnly
    >
      <DropdownMenu defaultSection="seasons">
        <AvailableSectionProvider initialAvailableSections={["season"]}>
          <MainSection />
          <SeasonsSection />
        </AvailableSectionProvider>
      </DropdownMenu>
    </ToggleButton>
  );
};
